import { useEffect, useState, useRef } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { api } from '@/lib/api'
import toast from 'react-hot-toast'

export function AuthCallback() {
  const navigate = useNavigate()
  const [searchParams, setSearchParams] = useSearchParams()
  const [error, setError] = useState<string | null>(null)
  const isProcessing = useRef(false) // Prevent duplicate API calls

  useEffect(() => {
    // Prevent duplicate processing
    if (isProcessing.current) return
    isProcessing.current = true

    const token = searchParams.get('token')
    const errorParam = searchParams.get('error')

    // Clean the URL (remove token/error from browser history)
    if (token || errorParam) {
      setSearchParams({}, { replace: true })
    }

    if (errorParam) {
      setError('Authentication failed. Please try again.')
      toast.error('Authentication failed')
      setTimeout(() => navigate('/login', { replace: true }), 2000)
      return
    }

    if (token) {
      // Store the token
      localStorage.setItem('auth_token', token)

      // Fetch user profile with the token
      api.get('/auth/profile')
        .then((response) => {
          const userData = response.data
          localStorage.setItem('user', JSON.stringify(userData))
          toast.success('Login successful!')
          navigate('/projects-map', { replace: true })
        })
        .catch((err) => {
          console.error('Failed to fetch user profile:', err)
          localStorage.removeItem('auth_token')
          setError('Failed to complete authentication')
          toast.error('Failed to complete authentication')
          setTimeout(() => navigate('/login', { replace: true }), 2000)
        })
    } else {
      setError('No authentication token received')
      toast.error('Authentication failed')
      setTimeout(() => navigate('/login', { replace: true }), 2000)
    }
  }, []) // Empty dependency - run only once on mount

  if (error) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-secondary-50">
        <div className="text-center">
          <div className="text-danger-600 text-lg mb-2">{error}</div>
          <div className="text-secondary-500">Redirecting to login...</div>
        </div>
      </div>
    )
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-secondary-50">
      <div className="text-center">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary-600 mx-auto mb-4"></div>
        <div className="text-secondary-600">Completing sign in...</div>
      </div>
    </div>
  )
}
